import styled from "styled-components"
import { BaseCard } from "../base-card/base-card.styles"
export const CTAContainer = styled(BaseCard)`
  grid-column: 10/13;
  height: fit-content;
  padding: 30px;
  & a {
    width: 100%;
    padding: 0;
    margin-top: 30px;
  }
  & button {
    width: 100%;
    padding: 0;
    margin-top: 30px;
  }
  @media screen and (max-width: 1400px) {
    grid-column: 9/13; /*remove spacer column to ensure btn text don't overflow*/
 
  @media screen and (max-width: 1000px) {
    grid-column: span 6;
  }
  @media screen and (max-width: 768px) {
    padding: 25px;
    grid-column: span 6;
    & a {
      margin-top: 25px;
    }
  }
`

export const CTATitle = styled.h5`
  margin: 0;
  ${({ theme: { typography } }) => typography.desktop.h5}
  @media screen and (max-width: 768px) {
    ${({ theme: { typography } }) => typography.mobile.h6}
  }
`
